const save = (id, filters) => {
    localStorage.setItem(_getKey(id), JSON.stringify(filters));
}

const load = (id) => {
    return JSON.parse(localStorage.getItem(_getKey(id))) || {};
}

const _getKey = (id) => `FILTERS:${id}`;

export default {
    save,
    load,
}
